import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let index = useDataValue({
    context: 'charge_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let charges = useDataValue({
    context: 'invoice',
    path: 'charges',
    viewPath: props.viewPath,
  })
  let changeClaim = useDataChange({
    context: 'claim',
    viewPath: props.viewPath,
  })
  let changeInvoice = useDataChange({
    context: 'invoice',
    viewPath: props.viewPath,
  })

  return function onClick(action) {
    switch (action) {
      case 'REMOVE':
        return removeCharge()
      case 'MOVE_TO_CLAIM':
        return moveToClaim()
      default:
        return
    }
  }

  function removeCharge() {
    changeInvoice(next => {
      next.charges.splice(index, 1)
    })
  }

  function moveToClaim() {
    changeClaim(next => {
      next.charges.push(charges[index])
    })
    changeInvoice(next => {
      next.charges.splice(index, 1)
    })
  }
}
